angular.module('myApp.terms', ['ngRoute'])

    .config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/business-terms', {
            templateUrl: 'components/terms/business.html',
            controller: 'termsCtrl'
        })
        $routeProvider.when('/terms', {
            templateUrl: 'components/terms/terms.html',
            controller: 'termsCtrl'    
        })
        $routeProvider.when('/privacy', {
            templateUrl: 'components/terms/privacy.html',
            controller: 'termsCtrl'
        })
    }])


    .controller('termsCtrl', ['$scope','$window',function( $scope, $window) {
        $window.scrollTo(0, 0);
        
    }]);